import { SectionBackground } from '@components/SectionBackground';
import { SimpleLink } from '@components/simpleLink';
import ReactMarkdown from 'react-markdown';
import { useFragment } from 'react-relay';
import SectionNavigation from '../../../sectionNavigation';
import { pageSectionClassName } from '../PageSectionsStyles';
import { overviewSectionFragment } from './OverviewSection.relay';
import type { OverviewSectionPropsType } from './types';

const OverviewSection: React.FC<OverviewSectionPropsType> = (props: OverviewSectionPropsType) => {
  const pageSection = useFragment(overviewSectionFragment, props.pageSection);

  return (
    <div className={pageSectionClassName}>
      {props.showImage && <SectionBackground anchorName={pageSection.anchorName} url={process.env.HOST + pageSection.titleImageUrl} backgroundUrl={process.env.HOST + pageSection.titleImageBackgroundUrl} />}
      <div id={props.showImage ? '' : pageSection.anchorName} className="section-content-wrapper">
        <div className="text-nav-wrapper">
          <div className="section-text">
            <h1 className="text-black font-light">{pageSection.title}</h1>
            <ReactMarkdown>{pageSection.overviewSectionText}</ReactMarkdown>
          </div>
          <SectionNavigation sectionNavigation={props.sectionNavigation} activeIndex={props.index} />
        </div>
        <SimpleLink simpleLink={pageSection.detailPageLink} />
      </div>
    </div>
  );
};

export { OverviewSection };
